import { Group, Radio as MantineRadio, RadioGroupProps } from '@mantine/core';
import cx from 'clsx';
import { FC, memo } from 'react';
import { useFormContext } from 'src/form';

import { Radio } from './Radio';
import styles from './styles.module.css';

type Option = {
  label: string;
  value: string;
  image?: string;
};

type Props = Omit<RadioGroupProps, 'name' | 'children'> & {
  name: string;
  data: Option[];
};

export const RadioGroup: FC<Props> = memo(({ name, data, ...props }) => {
  const form = useFormContext();

  const formProps = form.getInputProps(name);

  const hasError = !!formProps.error;

  return (
    <MantineRadio.Group
      classNames={{
        error: styles.error,
        label: styles.label,
        root: styles.root,
      }}
      size="md"
      {...props}
      {...formProps}
    >
      <Group>
        {data.map(({ label, value, image }) => (
          <label className={styles.option} key={value}>
            {image && (
              <img
                src={image}
                alt={label}
                className={cx({
                  [styles.image]: true,
                  [styles.imageSelected]: formProps.value === value,
                  [styles.imageError]: hasError,
                })}
              />
            )}
            <Radio value={value} label={label} />
          </label>
        ))}
      </Group>
    </MantineRadio.Group>
  );
});
